module.exports = __webpack_public_path__ + "static/media/sf-test-9.4ac191a5.mp3";